import React, { useEffect } from 'react';

const Ad = () => {
//   useEffect(() => {
//     const script = document.createElement('script');
//     script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2253055337011628";
//     script.async = true;
//     script.crossOrigin = "anonymous";
//     document.body.appendChild(script);

//     (window.adsbygoogle = window.adsbygoogle || []).push({});

//     return () => {
//       document.body.removeChild(script);
//     };
//   }, []);

//   useEffect(() => {
//     // Append the AdSense script if it's not already loaded
//     if (!document.querySelector("script[src*='adsbygoogle']")) {
//       const script = document.createElement('script');
//       script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
//       script.async = true;
//       script.crossOrigin = "anonymous";
//       document.head.appendChild(script);

//       // Only push to adsbygoogle once the script has loaded
//       script.onload = () => {
//         (window.adsbygoogle = window.adsbygoogle || []).push({});
//       };
//     } else {
//       // If script already exists, just push adsbygoogle
//       (window.adsbygoogle = window.adsbygoogle || []).push({});
//     }
//   }, []);

  useEffect(() => {
    const script = document.createElement('script');
    // script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
    script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2253055337011628";
    script.async = true;
    script.crossOrigin = "anonymous";
    document.head.appendChild(script);

    script.onload = () => {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    };
  }, []);

  return (
    <div>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-2253055337011628"
        data-ad-slot="f08c47fec0942fa0"
        // data-ad-client="ca-pub-3940256099942544"  // Test client ID
        // data-ad-slot="1234567890" 
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
    </div>
  );
};

export default Ad;
